import Vue from "vue";
import './plugins/axios'
import VueRouter from "vue-router";
import ActivationPlugin from "./activation";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import Functions from './globalFunctions.js'
import { VueMaskDirective } from 'v-mask'
import VueTinySlider from 'vue-tiny-slider'
import moment from 'moment'
import VueGtm from 'vue-gtm';

// router setup
import routes from "./routes/routes";

//Vuex Store
import store from './store/store'

// plugin setup
Vue.use(VueRouter);
Vue.use(ActivationPlugin);
Vue.use(VueTinySlider);

// console.log("===== VERSION =====");
// console.log(Vue.version);


Vue.directive('mask', VueMaskDirective);
Vue.directive('focus', {
  // When the bound element is inserted into the DOM, focus the element. Use "v-focus" at the template
  inserted: function (el) {    
    el.focus();
  }
});
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
});


// configure router
const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

// Google Tag Manager
Vue.use(VueGtm, {
  id: 'GTM-THX4HW', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)  
  trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
});

// global library setup
Vue.prototype.$Chartist = Chartist;

//Configure global functions
const functions = new Functions(router, store, $cookies);
Vue.prototype.$functions = functions;
Vue.prototype.$debug = (s) => functions.debug(s);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  store,
  router
});
